import VERB_CONSTANTS from './logConstants';

const defaultSubtitle = (log) => {
  return (
    log.action_object?.data?.shipper_data?.company_name ||
    log.target?.data?.shipper_data?.company_name
  );
};

const getPayloadStatus = (log) => {
  return log.action_object?.data?.status;
};

const subtitleConfig = {
  [VERB_CONSTANTS.INTEGRATION_STATUS_UPDATE]: {
    subtitle_function: getPayloadStatus,
  },
};

const getLogSubtitle = (log) => {
  const logFunction = subtitleConfig[log.verb]?.subtitle_function || defaultSubtitle;
  return logFunction(log);
};

export { defaultSubtitle };
export default getLogSubtitle;
